import type { SimpleArticleDocument, CategoriesByDistance, AdditionalArticle } from "@expert/types";

export const getExpArticle = async (id: string) => {
	const cached = useNuxtData("article/id=" + id);
	if (cached?.data?.value) {
		console.log("found cached article data");
		return cached;
	} else {
		return useFetch(useRuntimeConfig().public.apiUrl + `/api/search/article?articleId=${id}`, {
			key: "article/id=" + id,
		});
	}
}

export const getExpArticleCategory = (categoryId: string) => {
	if (categoryId === undefined)
		return { data: undefined };
	return useFetch(useRuntimeConfig().public.apiUrl + "/api/neo/article/categories", {
		query: {
			categoryId: categoryId,
		},
		key: `category/id=${categoryId}`,
	});
}

export const buildArticleLinkFromAdditionalArticle = (article: AdditionalArticle): string => {
	if (!article?.link?.startsWith('/shop/unsere-produkte')) {
		return '/shop/unsere-produkte/' + article?.link;
	}
	return article?.link;
}

export const buildArticleLinkFromHit = (item: SimpleArticleDocument): string => {
	return buildArticleLinkWithCategories('/shop/unsere-produkte', item?.primaryCategory?.id, item?.categoriesByDistance, item?.slug);
};

export const buildArticleLinkWithCategories = (baseDir: string, primaryCategoryId: string, categoriesByDistance: CategoriesByDistance, slug: string): string => {
	const primaryCategorySlug: string | undefined = categoriesByDistance?.['0']?.find(category => category?.id === primaryCategoryId)?.slug;
	const categoryTree: Array<string> = [
		categoriesByDistance?.['2']?.[0]?.slug ?? '',
		categoriesByDistance?.['1']?.[0]?.slug ?? '',
		primaryCategorySlug ?? categoriesByDistance?.['0']?.[0]?.slug ?? '',
	].filter(Boolean);
	const categoryPath: string = categoryTree.join('/');

	return [baseDir, categoryPath, slug].join('/');
};